module.exports = __webpack_public_path__ + "static/img/meeting_task.86605a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meeting_task.png
// module id = j5M5
// module chunks = 3